/**
 * Das Buch auf der Bühne.
 *
 * Schiebt die Ruhelage des Covers in Richtung Zeiger. Alles daran ist
 * Schmuck, deshalb passiert ohne feinen Zeiger gar nichts — ein Finger
 * kennt kein Hover, und ein Daumen, der die Seite scrollt, soll das Buch
 * nicht herumwirbeln. Unter „Bewegung reduzieren" ebenfalls nichts.
 *
 * Die Winkel stehen als eigene Eigenschaften, nicht als ganze
 * Transformation: so behält das Stylesheet die Ruhelage, und das
 * Schweben läuft darunter weiter.
 *
 * Übernommen aus dem englischen Shop (`assets/tm-stage.js`).
 */
(() => {
  const fein = window.matchMedia('(hover: hover) and (pointer: fine)');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fein.matches || still.matches) return;

  // Mehr als etwa zehn Grad, und das Cover sieht aus, als kippe es um.
  const MAX = 7;

  const start = () => {
    document.querySelectorAll('[data-bb-buehne]').forEach((buehne) => {
      if (buehne.dataset.bbBereit) return;
      const buch = buehne.querySelector('[data-bb-neigung]');
      if (!buch) return;
      buehne.dataset.bbBereit = '1';

      let bild = 0;

      buehne.addEventListener('pointermove', (e) => {
        if (bild) return;
        bild = requestAnimationFrame(() => {
          bild = 0;
          const r = buehne.getBoundingClientRect();
          if (!r.width || !r.height) return;
          const x = (e.clientX - r.left) / r.width - 0.5;
          const y = (e.clientY - r.top) / r.height - 0.5;
          buch.style.setProperty('--bb3-ry', (x * MAX * 2).toFixed(2) + 'deg');
          buch.style.setProperty('--bb3-rx', (-y * MAX).toFixed(2) + 'deg');
        });
      });

      buehne.addEventListener('pointerleave', () => {
        if (bild) { cancelAnimationFrame(bild); bild = 0; }
        buch.style.setProperty('--bb3-ry', '0deg');
        buch.style.setProperty('--bb3-rx', '0deg');
      });
    });
  };

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
})();
